import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class UserGuideService {
  isDashBoardPopUpShow: boolean = false;
  canShow = (name: string) =>
    !this.getCookie('userGuideHide').includes(
      '|' + name.split('/').pop().toLocaleLowerCase()
    );
  dontShow = (name: string) => {
    this.setCookie(
      'userGuideHide',
      this.getCookie('userGuideHide') + '|' + name
    );
  };
  // get userGuideText(): any[] {
  //   return JSON.parse(this.cookieService.get(this.localStorageKey)) as [];

  userGuideText = [
    {
      name: 'dashboard',
      content: {
        header: 'Home',
        videoLink: 'https://player.vimeo.com/video/895776964?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479',
      },
    },
    {
      name: 'trustedprofessionals',
      content: {
        header: 'Trusted Professional Advisors',
      },
    },
    {
      name: 'sharefeedback',
      content: {
        header: 'Share Feedback',
      },
    },

    {
      name: 'helpcenter',
      content: {
        header: 'Help Center',
        videoLink: '',
      },
    },
    {
      name: 'files',
      content: {
        bgIcon: 'files-modal-bg.svg',
        icon: 'files-blue.svg',
        header: 'Family Access Files',
        color: 'var(--maxYellowRed)',
        message:
          'Family Central’s files section provides information that you need in your everyday life at your fingertips. We help you organize your files family member wise to the tee!',
        videoLink:
          'https://player.vimeo.com/video/895778756?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479',
        boxContent: [
          {
            title: 'Organize',
            content:
              'You can drag a document or a folder from your desktop to your Family Central file folder',
          },
          {
            title: 'Customize',
            content:
              'Go to your <img src="https://familycentral.com/assets/images/breadcrumbsIcons/Files.svg"></img> on your task bar and open it up and copy any file or Folder Family Central file folder',
          },
          {
            title: 'Create',
            content: 'Click on the Add button to create a new folder.',
          },
        ],
      },
    },
    {
      name: 'personalvault',
      content: {
        bgIcon: 'personal-modal-bg.svg',
        icon: 'personal-blue.svg',
        header: 'Personal Vault',
        color: 'var(--cadet)',
        message:
          'Your Personal Vault is a private storage space for you. You can upload and manage sensitive documents for your eyes only.',
        boxContent: [
          {
            title: 'Drag, Drop, or Copy a Document Securely',
            content:
              'Drag and drop from your desktop to your Family Central file folder Go to your <img src="https://familycentral.com/assets/images/breadcrumbsIcons/Files.svg"></img>  on your task-bar And open it up then copy any file or folder securely.',
          },
          {
            title:
              'Create Your Own Custom Folder For You or Your Professionals',
            content:
              'Name Folders in ways that make sense to you and your family for today and in the future',
          },
          {
            title: 'Give Access to Your Trusted Professional Advisors',
            content:
              'You will send an invitation which Allows your advisors to deposit your information into your file folders securely so it is at your fingertips',
          },
        ],
        videoLink:
          'https://player.vimeo.com/video/895776366?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479',
      },
    },
    {
      name: 'calendar',
      content: {
        bgIcon: 'calendar-modal-bg.svg',
        icon: 'calendar-blue-icon.svg',
        header: 'Calendar',
        color: 'var(--medBlue)',
        message:
          'Help your family stay on top of upcoming events and milestones.',
        boxContent: [
          {
            title: 'Create Events',
            content: 'Create events to keep your family organized.',
          },
          {
            title: 'Create Milestones',
            content:
              'Add important dates, like birthdays or anniversaries, and get reminders.',
          },
        ],
        videoLink:
          'https://player.vimeo.com/video/895779479?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479',
      },
    },
    {
      name: 'legacyvideo',
      content: {
        bgIcon: 'legacy-modal-bg.svg',
        icon: 'legacy-blue.svg',
        header: 'Legacy Messages',
        color: 'var(--lightSeeGreen)',
        message:
          'Legacy Videos are a great way to leave behind a message to your loved ones, allowing you to share your story, and help your family remember you the way you wish. ',
        boxContent: [
          {
            title: 'Create and Upload Audio & Video Messages',
            content:
              'Use your Phone or Desktop camera to create a video and audio messages that you save to your Legacy Video folder.',
          },
          {
            title: 'Share Your Private Videos On Your Schedule',
            content:
              'Use our calendar feature to schedule when you want your audio and video messages to be shared with your family.',
          },
          {
            title: 'Decide Who Receives Your Private Audio & Video Messages',
            content:
              'You specify who receives each of your audio & video messages. Or, your Executor or Emergency Contact can share them upon your passing.',
          },
        ],
        videoLink:
          'https://player.vimeo.com/video/895778448?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479',
      },
    },
    {
      name: 'todolist',
      content: {
        bgIcon: 'todo-modal-bg.svg',
        icon: 'todo-blue.svg',
        header: 'To – Do',
        color: 'var(--medBlue)',
        message:
          'Prioritize your day with Family Central’s To-Do lists. Create tasks of all that you need to finish, collect, and bookmark information or make a list about anything!',
        boxContent: [
          {
            title: 'Create tasks and sub-tasks',
            content:
              'Click on the ADD button to start adding tasks. Create sub-tasks to manage tasks.',
          },
          {
            title: 'Assign tasks',
            content:
              'Free up your time. Assign and delegate tasks to your family members.',
          },
          {
            title: 'Set reminders',
            content: 'We will not let you forget. Here! Set a reminder.',
          },
        ],
        videoLink:
          'https://player.vimeo.com/video/722444300?h=43f9254978&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479',
      },
    },
    {
      name: 'photosvideos',
      content: {
        bgIcon: 'photo-modal-bg.svg',
        icon: 'photo-blue.svg',
        header: 'Photos & Videos',
        color: 'var(--bitterSweet)',
        message:
          'Stay connected with your family by posting photos & videos for everyone to enjoy!',
        boxContent: [
          {
            title: 'Organize & Create Albums',
            content:
              'Organize photos & videos for your family. Click the Add button to create a new album.',
          },
          {
            title: 'Click/Upload - Pictures & Videos',
            content: 'Click and upload pictures and videos on-the-go!',
          },
          {
            title: 'Share it',
            content:
              'Share your photos & videos with Family Central’s secure share link.',
          },
        ],
        videoLink:
          'https://player.vimeo.com/video/722444284?h=ef220f6cc6&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479',
      },
    },
    {
      name: 'gps',
      content: {
        bgIcon: 'gps-modal-bg.svg',
        icon: 'gps-blue.svg',
        header: 'GPS',
        color: 'var(--medBlue)',
        message:
          "Don't worry, GPS isn't about stalking your family members. This is where you can check-in to see if they’ve arrived at their destination safely.",
        boxContent: [
          {
            title: 'Location',
            content:
              'From the Settings menu on your phone, enable the Location setting or enable the location on your computer. This makes it possible for Family Central to connect with your family.',
          },
          {
            title: 'View current address & phone number',
            content:
              'Click on the tiny red dot to view their current address and your family member’s phone number.',
          },
        ],
        videoLink:
          'https://player.vimeo.com/video/895779751?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479',
      },
    },
    {
      name: 'emergency',
      content: {
        bgIcon: 'emergency-modal-bg.svg',
        icon: 'emergency-blue.svg',
        header: 'Emergency Prep',
        color: 'var(--fieryRose)',
        message:
          'Plan ahead for emergencies to ensure that your whole family knows how to get safe and reach each other.',
        boxContent: [
          {
            title: 'Organize & Plan',
            content:
              'Plan for an emergency with Family Central’s pre-defined folders, checklists, forms, and worldwide emergency information.',
          },
          {
            title: 'Customize & Create',
            content:
              'Create custom folders to meet your needs. These folders will be visible for all of your family to see.',
          },
        ],
        videoLink:
          'https://player.vimeo.com/video/895779079?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479',
      },
    },
    {
      name: 'myfamily',
      content: {
        bgIcon: 'emergency-modal-bg.svg',
        icon: 'myfamily1.png',
        header: 'My Family',
        color: 'var(--medBlue)',
        message:
          'Take stock! Have all of your family members registered? If not, send an invite!',
        boxContent: [
          {
            title: 'Invite Family',
            content:
              'Click the tiles to add family and friends. They’ll receive an email invite to join your family at Family Central.',
          },
          {
            title: 'Check-up on them',
            content:
              'Click on each of your family member’s tile to see what they are up to.',
          },
        ],
      },
    },
    {
      name: 'medical',
      content: {
        icon: 'medicalicon.png',
        header: 'Medical',
        color: 'var(--maxYellowRed)',
        message:
          'We help you organize your medical information for each family member in a central location!',
        boxContent: [
          {
            title: 'Organize',
            content: 'Organize your medical information all in one place.',
          },
          {
            title: 'Customize & Create',
            content:
              'Create custom folders by clicking the Add button in the top, right corner.',
          },
          {
            title: 'Create and/or Upload',
            content:
              'You can create new files and/or upload existing files and photos.',
          },
        ],
      },
    },
    {
      name: 'ids',
      content: {
        icon: 'idsIcon.png',
        header: 'IDs',
        color: 'var(--maxYellowRed)',
        message:
          'Stay organized by centralizing all the information you and your family need everyday!',
        boxContent: [
          {
            title: 'Organize',
            content:
              'Organize all of your IDs within pre-defined folders. Find the right ID at the right time!',
          },
          {
            title: 'Scan & Save',
            content: 'Scan and securely digitize all IDs on-the-go.',
          },
          {
            title: 'Customize & Create',
            content:
              'Create custom folders by clicking Add in the top, right corner.',
          },
        ],
      },
    },
    {
      name: 'insurance',
      content: {
        icon: 'insuranceIcon.png',
        header: 'Insurance',
        color: 'var(--maxYellowRed)',
        message:
          'Stay organized by centralizing all the information you and your family need everyday!',
        boxContent: [
          {
            title: 'Organize',
            content:
              'Save all your insurance information in pre-defined folders.',
          },
          {
            title: 'Customize & Create',
            content:
              'Create custom folders by clicking the Add button in the top, right corner.',
          },
          {
            title: 'Create and/or Upload',
            content:
              'You can create new files and/or upload existing files and photos.',
          },
        ],
      },
    },
    {
      name: 'importantcontacts',
      content: {
        icon: 'importantIcon.png',
        header: 'Important Contacts',
        color: 'var(--maxYellowRed)',
        message:
          'Stay organized by centralizing all the information you and your family need everyday!',
        boxContent: [
          {
            title: 'Organize',
            content:
              'Save as many contacts as you want in the Important Contacts section. Click the Add button to create a new contact.',
          },
        ],
      },
    },
    {
      name: 'disasterplanning',
      content: {
        icon: 'disasterlanningIcon.svg',
        header: 'Disaster Planning',
        color: 'var(--fieryRose)',
        message:
          'Plan ahead for emergencies to ensure that your whole family knows how to get safe and reach each other.',
        boxContent: [
          {
            title: 'Organize & Plan',
            content:
              'Plan ahead with Family Central’s pre-defined supply kit checklists, commuter plan, meeting place templates and forms.',
          },
          {
            title: 'Upload, Create or Just Click',
            content:
              'You can create new or upload pictures of emergency documents.',
          },
        ],
      },
    },
    {
      name: 'emergencyphonenumbers',
      content: {
        icon: 'emergencyphonenumbersIcon.png',
        header: 'Emergency Phone Numbers',
        color: 'var(--fieryRose)',
        message:
          'Plan ahead for emergencies to ensure that your whole family knows how to get safe and reach each other.',
        boxContent: [
          {
            title: 'Prepare',
            content:
              'Do not panic! All the help you need in case of an emergency is here. Click the Add button to save your emergency contacts.',
          },
        ],
      },
    },
    // {
    //   name: 'familyhealthcards',
    //   content: {
    //     icon: 'familyhealthcardsIcon.png',
    //     header: 'Family Health Cards',
    //     color: 'var(--fieryRose)',
    //     message:
    //       'Plan ahead for emergencies to ensure that your whole family knows how to get safe and reach each other.',
    //     boxContent: [
    //       {
    //         title: 'Prepare',
    //         content:
    //           'Record you and your family’s health profiles and history for easy access in an emergency.',
    //       },
    //     ],
    //   },
    // },
    {
      name: 'worldwideemergencynumbers',
      content: {
        icon: 'worldwideemergencynumbersIcon.png',
        header: 'Worldwide Emergency Numbers',
        color: 'var(--fieryRose)',
        message:
          'Plan ahead for emergencies to ensure that your whole family knows how to get safe and reach each other.',
        boxContent: [
          {
            title: 'Search and find',
            content:
              'You don’t have to panic during an emergency wherever you are! Select the country to see police, fire and medical contact numbers.',
          },
        ],
      },
    },

    {
      name: 'estateplan',
      content: {
        icon: 'estateIcon.svg',
        header: 'Estate Plan',
        color: 'var(--cadet)',
        message:
          'Your Vault is a private storage space for you. You can upload sensitive documents for your eyes only.',
        boxContent: [
          {
            title: 'Upload, Create or Just Click',
            content:
              'You can upload, click a picture of your important documents or create a new document.',
          },
          {
            title: 'Sharing',
            content:
              'Share your personal and sensitive information whenever you want, or we will release it to your executor upon your passing.',
          },
        ],
      },
    },
    {
      name: 'willtestament',
      content: {
        icon: 'willtestamentIcon.png',
        header: 'Will & Testament',
        color: 'var(--cadet)',
        message:
          'Your Vault is a private storage space for you. You can upload sensitive documents for your eyes only.',
        boxContent: [
          {
            title: 'Upload, Create or Just Click',
            content:
              'You can upload, click a picture of your important documents or create a new document.',
          },
          {
            title: 'Sharing',
            content:
              'Share your personal and sensitive information whenever you want, or we will release it to your executor upon your passing.',
          },
        ],
      },
    },
    {
      name: 'sharedwithme',
      content: {
        icon: 'sharedwithmeIcon.svg',
        header: 'Shared With Me',
        color: 'var(--cadet)',
        message:
          'Your Vault is a private storage space for you. You can upload sensitive documents for your eyes only.',
        boxContent: [
          {
            title: 'Upload, Create or Just Click',
            content:
              'You can upload, click a picture of your important documents or create a new document.',
          },
          {
            title: 'Sharing',
            content:
              'Share your personal and sensitive information whenever you want, or we will release it to your executor upon your passing.',
          },
        ],
      },
    },
    {
      name: 'powerofattorney',
      content: {
        icon: 'powerofattorneyIcon.svg',
        header: 'Power Of Attorney',
        color: 'var(--cadet)',
        message:
          'Your Vault is a private storage space for you. You can upload sensitive documents for your eyes only.',
        boxContent: [
          {
            title: 'Upload, Create or Just Click',
            content:
              'You can upload, click a picture of your important documents or create a new document.',
          },
          {
            title: 'Sharing',
            content:
              'Share your personal and sensitive information whenever you want, or we will release it to your executor upon your passing.',
          },
        ],
      },
    },
    // {
    //   name: 'securepasswordstorage',
    //   content: {
    //     icon: 'passwordmanagerIcon.svg',
    //     header: 'Secure Password Storage',
    //     color: 'var(--cadet)',
    //     message:
    //       'Your Personal Vault is a private storage space for you. You can upload and manage sensitive documents for your eyes only.',
    //     boxContent: [
    //       {
    //         title: 'Secure',
    //         content:
    //           'Save your email, social media, and other digital account passwords in Family Central&apos;s password manager. Click on the Add button to get started.',
    //       },
    //     ],
    //   },
    // },
    {
      name: 'funeralrequests',
      content: {
        icon: 'funeralrequestsIcon.svg',
        header: 'Funeral Requests',
        color: 'var(--cadet)',
        message:
          'Your Vault is a private storage space for you. You can upload sensitive documents for your eyes only.',
        boxContent: [
          {
            title: 'Organize & Plan',
            content: 'Plan ahead with Family Central’s pre-defined checklists.',
          },
          {
            title: 'Upload, Create or Just Click',
            content:
              'You can create new or upload pictures of emergency documents.',
          },
        ],
      },
    },
    {
      name: 'healthcareproxy',
      content: {
        icon: 'healthcareproxyIcon.svg',
        header: 'Health Care Proxy',
        color: 'var(--cadet)',
        message:
          'Your Vault is a private storage space for you. You can upload sensitive documents for your eyes only.',
        boxContent: [
          {
            title: 'Search & Find',
            content:
              'Nominate your Health care proxy with the help of our statewide proxy forms. Simply search for a state in the search bar to find relevant forms.',
          },
        ],
      },
    },
    {
      name: 'personalfinance',
      content: {
        icon: 'personalfinanceIcon.svg',
        header: 'Personal Finance',
        color: 'var(--cadet)',
        message:
          'Your Vault is a private storage space for you. You can upload sensitive documents for your eyes only.',
        boxContent: [
          {
            title: 'Scan & Save Invoices',
            content:
              'Scan and digitize all Invoices on the go. Extract and save vital information securely.',
          },
          {
            title: 'Customize & Create',
            content:
              'Create custom folders. Click on the ADD button to create a new folder.',
          },
        ],
      },
    },

    {
      name: 'loginpopup',
      content: {
        icon: 'familycentral-logo.svg',
        message:
          'Welcome to Family Central! Please click on our overview video or Get Started to start using your application.',
        videoLink: 'https://player.vimeo.com/video/783179420?h=4ed5e93581',
      },
    },
  ];
  private getCookie(name: string) {
    let ca: Array<string> = document.cookie.split(';');
    let caLen: number = ca.length;
    let cookieName = `${name}=`;
    let c: string;

    for (let i: number = 0; i < caLen; i += 1) {
      c = ca[i].replace(/^\s+/g, '');
      if (c.indexOf(cookieName) == 0) {
        return c.substring(cookieName.length, c.length);
      }
    }
    return '';
  }

  private deleteCookie(name) {
    this.setCookie(name, '', -1);
  }

  private setCookie(
    name: string,
    value: string,
    expireDays: number = 3600,
    path: string = '/'
  ) {
    let d: Date = new Date();
    d.setTime(d.getTime() + expireDays * 24 * 60 * 60 * 1000);
    let expires: string = `expires=${d.toUTCString()}`;
    let cpath: string = path ? `; path=${path}` : '';
    document.cookie = `${name}=${value}; ${expires}${cpath}`;
  }
}
